import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { toasterMessages } from '@messages/*';
import { ToastrService } from 'ngx-toastr';
import { LoginRegisterService } from '../login-register.service';

@Component({
  selector: 'app-employer-login',
  templateUrl: './employer-login.component.html',
  styleUrls: ['./employer-login.component.scss']
})

export class EmployerLoginComponent implements OnInit {
  @ViewChild('loginCmp') loginCmp: any;
  @ViewChild('registerCmp') registerCmp: any;
  selectedTab = null;
  token: any;
  adminExists = true;
  existingAdminEmail: any;
  signupView: string = '';

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private loginRegisterService: LoginRegisterService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe(params => {
      this.token = params.token;
      this.signupView = params.signupView;
    });
  }

  ngOnInit() {
    this.isUserExist();
    if (this.signupView === 'true') {
      this.changeTab(1);
    }
  }

  changeTab(tabNum) {
    this.selectedTab = tabNum;
  }

  onTabChange(index: number) {
    // Clear the inactive form when switching tabs to avoid persisting sensitive data
    if (index === 0 && this.registerCmp?.registerForm) {
      this.registerCmp.registerForm.reset();
    }
    if (index === 1 && this.loginCmp?.resetForm) {
      this.loginCmp.resetForm();
    }
  }

  /** send login request */
  loginSumbit(loginFormvalues) {
    if (this.adminExists) {
      this.existingUserlogin(loginFormvalues);
    }
  }

  private existingUserlogin(loginFormvalues) {
    this.loginRegisterService.loginRequest(loginFormvalues).subscribe((response) => {
      if (response.ssolink) {
        window.location = response.ssolink;
        return;
      }
      if (response.visitingFirstTime) {
        this.router.navigateByUrl('welcome');
      } else {
        this.router.navigateByUrl('/dashboard/home');
      }
    }, (err) => {
      if (err?.error?.errors?.[0]?.code === 401) {
        localStorage.setItem('userName', loginFormvalues.email);
        this.router.navigate([`verify-entrepreneur/resend-verify-token`]);
      } else {
        this.toastr.error(err?.error?.errors?.[0]?.error || err?.message, 'Error');
      }
    });
  }

  /** Check Candidate Exist or not */
  isUserExist() {
    if (this.token) {
      this.loginRegisterService.isAdminExist(this.token).subscribe((response) => {
        this.adminExists = response.adminExists;
        this.existingAdminEmail = response.email;
      }, (err) => {
        this.toastr.error(err?.error?.errors[0]?.error, 'Error');
      });
    }
  }

  /** send signup request */
  onRegister(registerFormValues) {
    this.loginRegisterService.signUpRequest(registerFormValues).subscribe((response) => {
      this.selectedTab = 0;
      this.toastr.success('Registration successful! Please check your email for verification.', 'Success');
      // Persist email so resend verification can include it after signup
      if (registerFormValues?.email) {
        localStorage.setItem('userName', registerFormValues.email);
      }
      this.router.navigate([`verify-entrepreneur`]);
    }, (err) => {
      this.toastr.error(err?.error?.errors[0]?.error, 'Error');
    });
  }

}
